module.exports = __webpack_public_path__ + "static/img/2019年01月.955c030.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brand/2019年01月.png
// module id = 53jp
// module chunks = 0